var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Welcome to CROSS-PLATFORM")]),_c('br'),_c('p',[_vm._v("Make a selection above to get started")])])}]

export { render, staticRenderFns }